import { createAsyncThunk } from '@reduxjs/toolkit';
import { getCrmOptions } from 'services/pod';
import { ICrmOption } from 'services/pod/types';

export const ThunkGetCrmOptions = createAsyncThunk<ICrmOption[]>('pod/getCrmOptions', async () => {
  const r = await getCrmOptions();
  return r.data;
});
